(function () {
  let instance = null;

  function destroy() {
    if (!instance) return;
    instance.teardown();
    instance = null;
  }

  function create(root, engines, chapters) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pin = root.querySelector('[data-hs-motion-pin]');
    const video = root.querySelector('[data-hs-motion-video]');
    const canvas = root.querySelector('[data-hs-motion-canvas]');
    const poster = root.querySelector('[data-hs-motion-poster]');
    const copies = [...root.querySelectorAll('[data-hs-copy]')];
    const ticks = [...root.querySelectorAll('[data-hs-motion-ticks] i')];
    const bar = root.querySelector('[data-hs-motion-bar]');
    const loader = root.querySelector('[data-hs-motion-loader]');
    const configEl = document.getElementById('hs-motion-config');
    let config = {};
    try {
      config = configEl ? JSON.parse(configEl.textContent) : {};
    } catch (_) {
      config = {};
    }
    const posters = config.posters || [];
    const lerp = window.HSMotionLerp || 0.085;
    const ac = new AbortController();
    const { signal } = ac;

    let target = 0;
    let current = 0;
    let raf = 0;
    let lastTick = 0;
    let mode = 'video';
    let scrubber = null;
    let sequence = null;
    let seekFails = 0;
    let visible = true;
    let readyTimer = 0;
    let canvasGen = 0;

    function runwayProgress() {
      const rect = root.getBoundingClientRect();
      const total = root.offsetHeight - window.innerHeight;
      if (total <= 1) return 0;
      return engines.clamp(-rect.top / total, 0, 1);
    }

    function layoutPin() {
      if (!pin || reduced) return;
      const rect = root.getBoundingClientRect();
      const vh = window.innerHeight;
      pin.style.left = '0';
      pin.style.right = '0';
      pin.style.width = '100%';
      if (rect.top > 0) {
        pin.style.position = 'absolute';
        pin.style.top = '0';
        pin.style.bottom = 'auto';
      } else if (rect.bottom > vh) {
        pin.style.position = 'fixed';
        pin.style.top = '0';
        pin.style.bottom = 'auto';
      } else {
        pin.style.position = 'absolute';
        pin.style.top = 'auto';
        pin.style.bottom = '0';
      }
    }

    function applyCopy(progress) {
      const { chapter, index } = engines.chapterAt(progress, chapters);
      const local = engines.localProgress(progress, chapter);
      const vis = engines.copyVisibility(local);
      copies.forEach((el) => {
        const on = el.dataset.hsCopy === chapter.id;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        const shown = on ? vis : 0;
        const y = (1 - shown) * 8;
        el.style.opacity = String(shown);
        el.style.transform = 'translate3d(0,' + y + 'px,0)';
        if (on) {
          el.querySelectorAll('.hs-motion__plaques span').forEach((s, i) => {
            const t = engines.clamp((shown - i * 0.14) / 0.72, 0, 1);
            s.style.opacity = String(t);
            s.style.transform = 'translate3d(0,' + ((1 - t) * 12) + 'px,0)';
          });
        }
      });
      ticks.forEach((tick, i) => tick.classList.toggle('is-on', i <= index));
      if (bar) bar.style.transform = 'scaleX(' + progress + ')';
      root.dataset.chapter = chapter.id;
    }

    function render(progress) {
      applyCopy(progress);
      layoutPin();
      const duration = scrubber ? scrubber.duration() : (window.HSMotionDuration || 14.95);
      const time = engines.progressToTime(progress, chapters, duration);
      if (mode === 'video' && scrubber) {
        const before = video.currentTime;
        scrubber.seek(time);
        if (Math.abs((video.currentTime || 0) - before) < 0.001 && Math.abs(time - before) > 0.08) {
          seekFails += 1;
          if (seekFails > 24 && sequence) {
            mode = 'canvas';
            if (video) video.hidden = true;
            if (canvas) canvas.hidden = false;
          }
        } else {
          seekFails = Math.max(0, seekFails - 1);
        }
      } else if (sequence) {
        sequence.draw(progress, chapters);
      }
      if (poster && progress > 0.02) poster.classList.add('is-dim');
    }

    function tick(now) {
      if (!visible && Math.abs(target - current) < 0.0008) {
        raf = 0;
        return;
      }
      raf = requestAnimationFrame(tick);
      if (now - lastTick < 33) return;
      lastTick = now;
      current += (target - current) * (reduced ? 1 : lerp);
      if (Math.abs(target - current) < 0.0008) current = target;
      render(current);
    }

    function startLoop() {
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function onScroll() {
      target = runwayProgress();
      layoutPin();
      startLoop();
    }

    function pickSource() {
      return config.src720 || config.src1080;
    }

    function showReady() {
      if (loader) loader.hidden = true;
      root.classList.add('is-ready');
    }

    function useCanvas() {
      mode = 'canvas';
      if (video) video.hidden = true;
      if (canvas) canvas.hidden = false;
      showReady();
    }

    function bindVideo() {
      if (!video) return;
      const src = pickSource();
      if (src && !video.querySelector('source') && !video.getAttribute('src')) {
        video.src = src;
      }
      if (posters[0]) video.poster = posters[0];
      video.muted = true;
      video.playsInline = true;
      video.preload = reduced ? 'none' : 'auto';
      try { video.load(); } catch (_) {}
      scrubber = new engines.VideoScrubber(video);
      video.addEventListener('loadedmetadata', showReady, { once: true, signal });
      video.addEventListener('canplay', showReady, { once: true, signal });
      video.addEventListener('error', () => {
        if (config.src1080 && video.src.indexOf('1080') === -1 && pickSource() !== config.src1080) {
          video.src = config.src1080;
          try { video.load(); } catch (_) {}
          return;
        }
        if (sequence) useCanvas();
        else showReady();
      }, { signal });
    }

    async function bindCanvas() {
      if (!canvas || !posters.length) return;
      const gen = ++canvasGen;
      sequence = new engines.CanvasSequence(canvas, posters);
      await sequence.load();
      if (gen !== canvasGen) return;
      if (reduced || !video) useCanvas();
    }

    bindVideo();
    bindCanvas();
    readyTimer = window.setTimeout(showReady, 1600);

    onScroll();
    current = target;
    render(current);
    window.addEventListener('scroll', onScroll, { passive: true, signal });
    window.addEventListener('resize', onScroll, { passive: true, signal });
    document.addEventListener('shopify:section:reorder', onScroll, { signal });

    if ('IntersectionObserver' in window) {
      const visIo = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          visible = entry.isIntersecting;
          if (visible) startLoop();
        });
      }, { rootMargin: '20% 0px' });
      visIo.observe(root);
      ac.signal.addEventListener('abort', () => visIo.disconnect());
      if (video && !reduced) {
        const loadIo = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) video.preload = 'auto';
          });
        }, { rootMargin: '120% 0px' });
        loadIo.observe(root);
        ac.signal.addEventListener('abort', () => loadIo.disconnect());
      }
    }

    startLoop();

    return {
      teardown() {
        window.clearTimeout(readyTimer);
        canvasGen += 1;
        cancelAnimationFrame(raf);
        raf = 0;
        ac.abort();
        if (pin) {
          pin.style.position = '';
          pin.style.top = '';
          pin.style.bottom = '';
          pin.style.left = '';
          pin.style.right = '';
          pin.style.width = '';
        }
        if (scrubber) scrubber.destroy();
        if (sequence) sequence.destroy();
      }
    };
  }

  function boot() {
    destroy();
    const root = document.querySelector('[data-hs-motion]');
    if (!root) return;
    const engines = window.HSMotionEngines;
    const chapters = window.HSMotionChapters || [];
    if (!engines || !chapters.length) return;
    instance = create(root, engines, chapters);
  }

  function start() {
    let n = 0;
    (function wait() {
      if (window.HSMotionEngines && window.HSMotionChapters && window.HSMotionChapters.length) {
        boot();
        return;
      }
      if (++n < 180) requestAnimationFrame(wait);
    })();
  }

  if (window.__hsMotionBound) {
    start();
    return;
  }
  window.__hsMotionBound = true;
  window.HSMotionStart = start;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-hs-motion]')) start();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-hs-motion]')) destroy();
  });
  window.addEventListener('pagehide', destroy);
})();
